import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import {AppComponent} from '../../app.component';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { element } from 'protractor';

export class FetchCommunityData {
  AllocateCompany: string;
  ConsumedCompany: string;
}

export interface FilterData {
  filter: string;
  AdvanceSearch: any;
  Type: string;
}

@Component({
    selector: 'app-nav-company',
    templateUrl: './nav-company.component.html',
    styleUrls: ['./nav-company.component.css'],
    standalone: false
})
export class NavCompanyComponent implements OnInit {
  master: any;
  CompanyMaster: any;
  url: string;
  pageurl: string;
  TypeHeader: string;
  MsgType: number;
  DisplayMessage: string;
  FormSearchContactOrg: FormGroup;
  advanceSearchValue: any;
  modalURL: any;
  ModelFor: string;
  CallFunctionOnCloseModal: any;
  pageNumber: number;
  RightsID: string;
  pagetype: string;
  CompanyCondition: any;
  totalAssignCompany: any;
  TotalConsumedCompany: any;
  filteredData: any[] = [];
  pageSize = 10;
  pageIndex = 0;
  totalRecords = 0;
  constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder) { this.url = AppComponent.baseURL; }

  ngOnInit() {
    this.RightsID = localStorage.getItem('UserRight');
    if (this.RightsID.includes('202044001') || this.RightsID.includes('202044021') || this.RightsID.includes('202044000')) {
      } else {
        window.location.href="module/0";
      }
    this.pageNumber = 1;
    this.MsgType = 1; // Loading
    this.pageurl = this.router.url;
    let pagehead = this.pageurl.split('/');
    this.pagetype = pagehead[2];
    this.FetchCompanyList();
    this.FormSearchContactOrg = this.formBuilder.group({
      txtSearch: ['']
    });
    this.TypeHeader = pagehead[2].toString();
    if (pagehead[2].toString() == 'Org') {this.TypeHeader = 'Organization'; } else {
      this.TypeHeader = pagehead[2].toString();
    }
    let element: HTMLElement;
    element = document.getElementsByClassName('modal-backdrop')[0] as HTMLElement;
    if (element != null) {
      element.remove();
    }
    this.FormSearchContactOrg.get('txtSearch').valueChanges
    .pipe(
      debounceTime(300),
      distinctUntilChanged()
    )
    .subscribe(value => {
      this.filterTable(value);
    })
  }

  onPageSizeChange(size: number) {
    this.pageSize = size;
    this.pageNumber = 1; 
    this.filterTable('')
  }
  receiveMessage(event) {
    if (event?.data?.data?.Param != null){
      localStorage.setItem('advancesearch', event.data.data.Param);
      let element: HTMLElement;
      element = document.getElementsByClassName('close')[0] as HTMLElement;
      element.click();
    }
  }
  ReturnAdvanceSearch() {
    this.advanceSearchValue = JSON.parse(localStorage.getItem('advancesearch'));
    localStorage.setItem('advancesearch', "");
    this.FetchCompanyList();
  }
  onSearchContactOrg(SearchData) {
    this.http.get(this.url + 'Company/FetchNavCompany?filter=' + SearchData.txtSearch)
    .subscribe( (data) => {
      if (data == null || data.toString() == "[]") {
        this.MsgType = 2; // No Data Found
        this.DisplayMessage = "No Data Found";
        this.CompanyMaster = null;
        this.filteredData = [];
      } else {
        this.MsgType = 0; // No Message
        this.CompanyMaster = JSON.parse(data.toString());
      }
      },
      (error) => {
         this.MsgType = 3; // Error Message
         this.DisplayMessage = error.message;
       }
    );
  }

  FetchCompanyList() {
    this.http.get(this.url + 'Company/FetchNavCompany?filter=' + '')
    .subscribe( (data) => {
      if (data == null || data.toString() == "[]") {
        this.MsgType = 2; // No Data Found
        this.DisplayMessage = "No Data Found";
        this.CompanyMaster = null;
      } else {
        this.MsgType = 0; // No Message
        this.CompanyMaster = JSON.parse(data.toString());
        this.totalRecords = this.CompanyMaster.length;
        this.filteredData = [...this.CompanyMaster];
      }
      this.http.get(this.url + 'CommunityDetail/FetchCommunityDetail')
      .subscribe( (data1) =>   {
          if (data1 == null) {  } else {
            const CommunityData: FetchCommunityData = JSON.parse(data1.toString())[0];
            this.totalAssignCompany=+CommunityData.AllocateCompany;
            this.TotalConsumedCompany=+CommunityData.ConsumedCompany;
            if(this.TotalConsumedCompany<this.totalAssignCompany){this.CompanyCondition=1;}else{this.CompanyCondition=0;}
        }});
    
      },
      (error) => {
         this.MsgType = 3; // Error Message
         this.DisplayMessage = error.message;
       }
    );
  }
  filterTable(searchText: string) {
    if (!searchText) {
      this.filteredData = [...this.CompanyMaster];
      return;
    }

    this.filteredData = this.CompanyMaster.filter(row =>
      Object.values(row).some(val =>
        val?.toString().toLowerCase().includes(searchText.toLowerCase())
      )
    );
    this.pageNumber = 1;
  }  
}
